"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const extractParamWithEntryVar = async ({ entryVar, params, evaluateEntryVar, }) => {
    var _a, _b, _c;
    if ((0, valueIsString_1.default)(entryVar === null || entryVar === void 0 ? void 0 : entryVar.subPath)) {
        return {
            value: params === null || params === void 0 ? void 0 : params[entryVar.subPath],
            dataPropName: entryVar === null || entryVar === void 0 ? void 0 : entryVar.subPath,
        };
    }
    if ((_a = entryVar === null || entryVar === void 0 ? void 0 : entryVar.subPath) === null || _a === void 0 ? void 0 : _a.value) {
        const pageInputData = params === null || params === void 0 ? void 0 : params[entryVar.subPath.value];
        if ((_b = entryVar === null || entryVar === void 0 ? void 0 : entryVar.subPath) === null || _b === void 0 ? void 0 : _b.subAtribute) {
            if (typeof entryVar.subPath.subAtribute === 'string') {
                return {
                    value: (0, getValueByPathFromUnknown_1.default)(pageInputData, (_c = entryVar === null || entryVar === void 0 ? void 0 : entryVar.subPath) === null || _c === void 0 ? void 0 : _c.subAtribute.split('.')),
                    dataPropName: entryVar.subPath.value,
                };
            }
            const prop = await evaluateEntryVar(entryVar.subPath.subAtribute);
            if (typeof prop === 'string') {
                return {
                    value: (0, getValueByPathFromUnknown_1.default)(pageInputData, prop.split('.')),
                    dataPropName: entryVar.subPath.value,
                };
            }
        }
        return {
            value: pageInputData,
            dataPropName: entryVar.subPath.value,
        };
    }
    return undefined;
};
exports.default = extractParamWithEntryVar;
